const NAVBAR_WIDTH = 72;
const EXPAND_COLUMN_AFTER_MIN_WIDTH = 80;
const COLLAPSED_SECTION_WIDTH = 64;
const MINIMUM_SECTION_WIDTH = 224;
export const MAX_SECTION_WIDTH = 840;

export const useDocViewDimensions = (windowWidth: number) => {
  const minSectionWidth = MINIMUM_SECTION_WIDTH;
  const docAreaWidth = windowWidth - NAVBAR_WIDTH;
  const minSectionPercentage = (minSectionWidth / docAreaWidth) * 100;
  const minDocAreaPercentage = 2 * minSectionPercentage;
  const collapsedSectionPercentage =
    (COLLAPSED_SECTION_WIDTH / docAreaWidth) * 100;
  const maxSectionPercentage = (MAX_SECTION_WIDTH / docAreaWidth) * 100;
  const minWidthToExpand = (EXPAND_COLUMN_AFTER_MIN_WIDTH / docAreaWidth) * 100;

  return {
    minSectionWidth,
    docAreaWidth,
    minSectionPercentage,
    minDocAreaPercentage,
    collapsedSectionPercentage,
    maxSectionPercentage,
    minWidthToExpand,
  };
};
